module.exports = require("@swa-ui/core/src/SelectList/SelectList.module.scss");